import { PaymentMethodEnum } from '@/types/common';
import { useMemo } from 'react';
import { CreditCardBox } from '../PaymentMethodsBoxes/CreditCardBox';
import { PaypalBox } from '../PaymentMethodsBoxes/PaypalBox';
import { GooglePayBox } from '../PaymentMethodsBoxes/GooglePayBox';
import { OtherPaymentMethod } from '../PaymentMethodsBoxes/Other';
import { KlarnaBox } from '../PaymentMethodsBoxes/KlarnaBox';
import { CashAppBox } from '../PaymentMethodsBoxes/CashAppBox';
import { ApplePayBox } from '../PaymentMethodsBoxes/ApplePayBox';
import { LinkBox } from '../PaymentMethodsBoxes/LinkBox';
import { UnionPayBox } from '../PaymentMethodsBoxes/UnionPayBox';
import { VerifoneBox } from '../PaymentMethodsBoxes/VerifoneBox';
import { AmazonPayBox } from '../PaymentMethodsBoxes/AmazonPayBox';
import { IdealPayBox } from '../PaymentMethodsBoxes/IdealPayBox';
import { AffrimPayBox } from '../PaymentMethodsBoxes/AffrimPayBox';
import { AfterPayBox } from '../PaymentMethodsBoxes/AfterPay';
import { PixPayBox } from '../PaymentMethodsBoxes/PixPayBox';
import { NeosurfPayBox } from '../PaymentMethodsBoxes/NeosurfPaybox';
import { BlikPayBox } from '../PaymentMethodsBoxes/BlikPayBox';
import { P24PayBox } from '../PaymentMethodsBoxes/P24PayBox';
import { EPSPayBox } from '../PaymentMethodsBoxes/EPSPayBox';
import { BancontactPayBox } from '../PaymentMethodsBoxes/BancontactPayBox';
import { AlipayPayBox } from '../PaymentMethodsBoxes/AlipayPayBox';
import { PaymePayBox } from '../PaymentMethodsBoxes/PaymePayBox';
import { VenmoBox } from '../PaymentMethodsBoxes/VenmoBox';

interface PaymentMethodProps {
  paymentMethod: PaymentMethodEnum;
}

export const PaymentMethod = ({ paymentMethod }: PaymentMethodProps) => {
  const PaymentMethodComponent = useMemo(() => {
    switch (paymentMethod) {
      case PaymentMethodEnum.CREDIT_CARD:
        return <CreditCardBox />;
      case PaymentMethodEnum.PAYPAL:
        return <PaypalBox />;
      case PaymentMethodEnum.GOOGLE_PAY:
        return <GooglePayBox />;
      case PaymentMethodEnum.APPLE_PAY:
        return <ApplePayBox />;
      case PaymentMethodEnum.CASH_APP:
        return <CashAppBox />;
      case PaymentMethodEnum.KLARNA:
        return <KlarnaBox />;
      case PaymentMethodEnum.AMAZON_PAY:
        return <AmazonPayBox />;
      case PaymentMethodEnum.PIX:
        return <PixPayBox />;
      case PaymentMethodEnum.LINK:
        return <LinkBox />;
      case PaymentMethodEnum.UNIONPAY:
        return <UnionPayBox />;
      case PaymentMethodEnum.VERIFON:
        return <VerifoneBox />;
      case PaymentMethodEnum.IDEAL:
        return <IdealPayBox />;
      case PaymentMethodEnum.AFFIRM:
        return <AffrimPayBox />;
      case PaymentMethodEnum.OTHER:
        return <OtherPaymentMethod />;
      case PaymentMethodEnum.AFTERPAY:
        return <AfterPayBox />;
      case PaymentMethodEnum.NEOSURF:
        return <NeosurfPayBox />;
      case PaymentMethodEnum.NUVEI_NEOSURF:
        return <NeosurfPayBox />;
      case PaymentMethodEnum.BLIK:
        return <BlikPayBox />;
      case PaymentMethodEnum.BLIK_CHECKOUT:
        return <BlikPayBox />;
      case PaymentMethodEnum.P24:
        return <P24PayBox />;
      case PaymentMethodEnum.EPS:
        return <EPSPayBox />;
      case PaymentMethodEnum.BANCONTACT:
        return <BancontactPayBox />;
      case PaymentMethodEnum.ALIPAY:
        return <AlipayPayBox />;
      case PaymentMethodEnum.PAYME:
        return <PaymePayBox />;
      case PaymentMethodEnum.VENMO:
        return <VenmoBox />;

      default:
        return null;
    }
  }, [paymentMethod]);
  return (
    <div data-testid={`payment-method-${paymentMethod.toLowerCase().replace(/_/g, '-')}`} className="w-full">
      {PaymentMethodComponent}
    </div>
  );
};
